import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { memo } from "react";
import { EmptyState } from "../../../../../components/emptyState/emptyState";
import {
  contractColumns,
  receivablesColumns,
  sortIcon,
  taxNotesColumns,
} from "../../constants";
import RecursiveGroupedTableRow from "./RecursiveGroupedTableRow";

const ReportTable = ({
  emptyMessage = "Sem dados",
  errorMessage,
  data,
  columns,
  sort,
}) => {
  return (
    <>
      <TableContainer
        style={{
          maxHeight: "70vh",
          borderBottom: "1px solid #e3e3e3",
        }}
      >
        <Table aria-label="customized table" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                colSpan={contractColumns.length}
                align="center"
                style={{
                  border: "none",
                  backgroundColor: "#d6e5ff",
                }}
              >
                Contratos
              </TableCell>
              <TableCell
                colSpan={receivablesColumns.length}
                align="center"
                style={{
                  border: "none",
                  backgroundColor: "#E2F1FF",
                }}
              >
                Contas a Receber
              </TableCell>
              <TableCell
                colSpan={taxNotesColumns.length}
                align="center"
                style={{ backgroundColor: "#d6e5ff", border: "none" }}
              >
                NFSe
              </TableCell>
            </TableRow>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  align={column.align}
                  key={column.id}
                  onClick={!!column.sorting ? () => sort(column) : null}
                  style={{
                    backgroundColor: column.cellColor ?? "#d6e5ff",
                    fontSize: "0.855rem",
                    minWidth: column.minWidth,
                    cursor: !!column.sorting ? "pointer" : "default",
                  }}
                >
                  <Grid
                    container
                    direction="row"
                    spacing={1}
                    style={{
                      flexWrap: "nowrap",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <Grid
                      item
                      xs={!!column.align}
                      style={{ textAlign: column.align }}
                    >
                      {column.label}
                    </Grid>

                    {!!column.sorting && (
                      <Grid item>{sortIcon[column.sorting]}</Grid>
                    )}
                  </Grid>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {errorMessage ? (
              <TableRow>
                <TableCell align="center" colSpan={columns.length}>
                  {errorMessage}
                </TableCell>
              </TableRow>
            ) : data?.length ? (
              data?.map((cell, cellIndex) => {
                return (
                  <RecursiveGroupedTableRow
                    cell={cell}
                    key={cellIndex}
                    level={1}
                  />
                );
              })
            ) : (
              <TableRow>
                <TableCell align="center" colSpan={columns.length}>
                  <EmptyState message={emptyMessage} />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default memo(ReportTable);
